module.exports = __webpack_public_path__ + "img/x5.f343b1c2.jpg";